<template>
    <div class="h-full report-box">
        <div class="search-box">
            <div class="search-box-top">
                <el-tabs v-model="tabValue" @tab-change="handleClick">
                    <el-tab-pane label="公开报告" name="first"></el-tab-pane>
                    <el-tab-pane label="VIP专区" name="second"></el-tab-pane>
                    <el-tab-pane label="定制报告" name="third"></el-tab-pane>
                </el-tabs>
                <el-input
                    v-model="searchParams.name"
                    class="search-input"
                    placeholder="搜索报告"
                >
                    <template #suffix>
                        <i class="iconfont icon-shousuo0"></i>
                    </template>
                </el-input>
            </div>
            <div class="search-box-content" v-if="tabValue!=='third'">
                <div class="report-form">
                    <div class="report-label">
                        报告类型
                    </div>
                    <div class="report-formItem">
                        <div v-if="changeSelectType">
                            <div class="checkbox-box">
                                <el-checkbox-group v-model="checkTypeList">
                                    <el-checkbox v-for="item in reportList" :label="item" :key="item"/>
                                </el-checkbox-group>
                                <div class="checkbox-btn">
                                    <el-button @click="handleCancel('types')" size="small">取消</el-button>
                                    <el-button size="small" @click="handleChangeSearch('types')" type="primary">确定
                                    </el-button>
                                </div>
                            </div>
                        </div>

                        <div v-else class="radio-box">
                            <div>
                                <span :class="{'active-select':selectType===''}"
                                      @click="handleChangeType('')">全选</span>
                                <span :class="{'active-select':selectType===item}"
                                      @click="handleChangeType(item)" v-for="item in reportList" :key="item">{{
                                        item
                                    }}</span>
                            </div>
                            <el-button @click="changeSelectType=true" class="changeBtn" size="small" plain>多选
                            </el-button>
                        </div>
                    </div>
                </div>

                <div class="report-form">
                    <div class="report-label">
                        城市
                    </div>
                    <div class="report-formItem" style="position: relative;">
                        <!-- <el-cascader
                            ref="selectArea"
                            v-model="searchParams.cityCodes"
                            :props="{label:'name',value:'code'}"
                            :options="options"
                            placeholder="请选择"
                            clearable
                            @change="handleGetCity"
                        /> -->
                        <div style="width:150px; margin-top: 6px;" class="city-report-box">
                            <CitySelect v-model="searchParams.cityCodes"></CitySelect>
                        </div>
                    </div>
                </div>
                <div class="report-form">
                    <div class="report-label">
                        年份
                    </div>
                    <div class="report-formItem">
                        <div v-if="changeSelectYear">
                            <div class="checkbox-box">
                                <el-checkbox-group v-model="checkYearList">
                                    <el-checkbox v-for="item in yearList" :label="item" :key="item"/>
                                </el-checkbox-group>
                                <div class="checkbox-btn">
                                    <el-button @click="handleCancel('years')" size="small">取消</el-button>
                                    <el-button size="small" @click="handleChangeSearch('years')" type="primary">确定
                                    </el-button>
                                </div>
                            </div>
                        </div>

                        <div v-else class="radio-box">
                            <div>
                                <span :class="{'active-select':selectYear===''}"
                                      @click="handleChangeYear('')">全选</span>
                                <span :class="{'active-select':selectYear===item}" @click="handleChangeYear(item)"
                                      v-for="item in yearList" :key="item">{{ item }}</span>
                            </div>
                            <el-button @click="changeSelectYear=true" class="changeBtn" size="small" plain>多选
                            </el-button>
                        </div>
                    </div>
                </div>


            </div>
            <div class="report-result"
                 v-if="searchParams.types.length&&(selectType||checkTypeList.length)||selectStr.length||searchParams.years.length&&(selectYear||checkYearList.length)">
                <div class="result-label">已选结果：</div>
                <div class="result-list">
                    <div v-if="searchParams.types.length&&(selectType||checkTypeList.length)" >
                        <div  class="type-box"> 报告类型：{{ searchParams.types.join('、') }}</div> <i  @click="handleRest(1)" class="iconfont icon-guanbi0"></i>
                    </div>
                    <div v-if="selectStr.length" >
                        <div  class="type-box"> 城市：{{ selectStr.join('') }}</div> <i  @click="handleRest(2)" class="iconfont icon-guanbi0"></i>

                        </div>
                    <div v-if="searchParams.years.length&&(selectYear||checkYearList.length)">
                       <div  class="type-box"> 年份：{{ searchParams.years.join('、') }}</div> <i   @click="handleRest(3)" class="iconfont icon-guanbi0"></i>
                    </div>
                </div>
            </div>
        </div>

        <div class="record-list" v-if="list.length">
            <el-row :gutter="20">
                <el-col :xl="8" :lg="12" v-for="item in list" :key="item.id">
                    <ReportItem :type="tabValue==='first'?1:tabValue==='second'?2:3" :item="item" @getReportList="getList"></ReportItem>
                </el-col>
            </el-row>
            <div v-if="list.length" class="page-box">
                <el-pagination
                    small
                    layout="prev, pager, next,jumper"
                    :total="total"
                    v-model:page-size="searchParams.pageSize"
                    hide-on-single-page
                    @update:current-page="handleChangePage"
                >
                </el-pagination>
            </div>

        </div>
        <div class="not-tip" v-else>
            <el-empty :image-size="200" description="暂无数据"/>
        </div>
    </div>
</template>
<script setup>
import ReportItem from '@/components/reportItem'
import CitySelect from '@/components/citySelect'
import {onMounted, ref, watch} from "vue";
import request from "@/service/request";
import {getAddressTree, getCustomReport, getPublicReport, getVIPReport} from "@/service/api";

const tabValue = ref('first')

const reportList = ref(['通用仓储报告', '物流地产报告', '区域及专题报告', '冷库报告'])
const y = new Date().getFullYear()
const yearList = ref([])


const searchParams = ref({
    pageSize: 8,
    pageNum: 1,
    name: "",
    years: [],
    cityCodes: "",
    types: []
})
// 清除  num 1- 报告类型 2-城市 3-年份
const handleRest = num =>{
    switch (num){
        case 1:
            handleChangeType()
            checkTypeList.value = []
            break;
        case 2:
            handleGetCity()
            searchParams.value = {
                ...searchParams.value,
                cityCodes:""
            }
            break;
        case 3:
            handleChangeYear()
            checkYearList.value = []
    }
}


/** 多选切换逻辑  **/
const changeSelectType = ref(false)
const changeSelectYear = ref(false)
/** 多选 **/
const checkTypeList = ref([])
const checkYearList = ref([])

/**城市**/
const options = ref([])
// 切换tab
const handleClick = (tab) => {
    tabValue.value = tab
    searchParams.value = {
        pageSize: 8,
        pageNum: 1,
        name: "",
        years: [],
        cityCodes: "",
        types: []
    }
    selectStr.value = []
    selectType.value = ''
    selectYear.value = ''
}
const selectArea = ref()
const selectStr = ref([])
const handleGetCity = (e) => {
    if (e) {
        let node = selectArea.value.getCheckedNodes()
        selectStr.value = node[0].pathLabels
    } else {
        selectStr.value = []
    }

}

const handleChangeSearch = (name) => {
    searchParams.value = {
        ...searchParams.value,
        [name]: name === 'types' ? [...checkTypeList.value] : [...checkYearList.value]
    }
}
const handleCancel = (name) => {
    if (name === 'types') {
        changeSelectType.value = false
        checkTypeList.value = []
        selectType.value = ''
    } else {
        changeSelectYear.value = false
        checkYearList.value = []
        selectYear.value = ''

    }
    searchParams.value = {
        ...searchParams.value,
        [name]: name === 'types' ? [...reportList.value] : [...yearList.value]
    }
}
/** 切换报告类型 **/
const selectType = ref('')
const handleChangeType = name => {
    selectType.value = name
    searchParams.value = {
        ...searchParams.value,
        types: name ? [name] : reportList.value
    }
}
/** 切换年份 **/
const selectYear = ref('')
const handleChangeYear = name => {
    selectYear.value = name
    searchParams.value = {
        ...searchParams.value,
        years: name ? [name] : yearList.value
    }
}

const handleChangePage = (page) => {
    searchParams.value = {
        ...searchParams.value,
        pageNum: page
    }
}

watch(() => [searchParams.value.pageNum, searchParams.value.types, searchParams.value.cityCodes, searchParams.value.years, searchParams.value.name, tabValue.value], () => {
    getList()
})

const list = ref([])
const total = ref(0)

const getList = async () => {
    console.log('333333');
    
    let url = tabValue.value === 'first' ? getPublicReport : tabValue.value === 'second' ? getVIPReport : getCustomReport
    let data = await request({
        url: url,
        method: 'post',
        data: {
            ...searchParams.value
        }
    })
    list.value = data.rows
    total.value = data.total
}
// 获取省市区地址
const getTree = async () => {
    let {data} = await request({
        url: getAddressTree,
        data: {
            filterateaear: true
        }
    })
    options.value = data.provinces || []
}
onMounted(() => {
    getList()
    getTree()
    let arr = []
    for (let i = 0; i < 6; i++) {
        arr.push(y - i)
    }
    yearList.value = [...arr]
})
</script>

<style lang="less">
.report-box{
    padding: 0 30px;
    width: 100%;
    box-sizing: border-box;
}
.search-box {
    .search-box-top {
        .el-tabs__header {
            .el-tabs__nav-wrap::after {
                width: 0;
            }

            .el-tabs__nav-wrap {
                padding: 0 30px;
            }
            .el-tabs__item{
                font-weight: 600;
            }
            .el-tabs__item.is-active {
                color: @text-color-title !important;

            }

            .el-tabs__active-bar {
                height: 4px;
                background: #1378D7;
                border-radius: 2px;

            }
        }

        .search-input {
            width: 362px;
            border: 0;
            border-bottom: 1px solid #ddd;
            height: 32px;

            .el-input__wrapper {
                box-shadow: none;

                &:hover {
                    box-shadow: none;
                }
            }

            .icon-shousuo0 {
                font-size: 18px;
                color: #1477C9;
            }
        }


    }

    .el-button--primary {
        background: #1477C9;
    }
}

.page-box {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 50px 0;

    .el-pagination {
        .el-pager li {
            background: #F8F8F8;
        }

        button {
            background: #F8F8F8;
        }
    }
}
.city-report-box{
    &>.city-select-box>.city-select-control{
        background: #fff;

    }
}
</style>
<style lang="less" scoped>
.search-box {
    width: 100%;
    background: #FFFFFF;
    padding: 30px;


    .search-box-top {
        display: flex;
        justify-content: space-between;

    }

    .report-result {
        width: 100%;
        margin-top: 20px;
        display: flex;
        font-size: 14px;
        color: @text-color-title;
        align-items: center;

        .result-label {
            flex-shrink: 0;
        }

        .result-list {
            flex: 1;
            display: flex;
            align-items: center;

            & > div {
                height: 30px;
                border: 1px solid #DDDDDD;
                border-radius: 2px;
                padding: 0 10px;
                cursor: pointer;
                margin-left: 10px;
                align-items: center;
                display: flex;
                &:hover {
                    border: 1px solid #1A77D6;
                    .icon-guanbi0 {
                        color: #1A77D6;
                    }
                }
                .type-box {
                    max-width: 300px;
                    font-size: 14px;
                    color: #333333;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    box-sizing: border-box;
                    line-height: 30px;
                }
                .icon-guanbi0{
                    font-size: 12px;
                    color: #666;
                    flex-shrink: 0;
                    margin-left: 10px;
                }
            }
        }
    }

    .search-box-content {
        width: 100%;
        background: #F8F8F8;
        //border: 1px solid #DDDDDD;

        .report-form {
            display: flex;
            font-size: 14px;
            color: @text-color-title;
            //border-bottom: 1px solid #DDDDDD;


            .report-label {
                width: 140px;
                text-align: center;
                line-height: 48px;
                font-weight: 600;
            }

            .report-formItem {
                line-height: 48px;
                //border-left: 1px solid #DDDDDD;
                padding-left: 40px;
                padding-right: 20px;
                width: 100%;
                box-sizing: border-box;

                .radio-box {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    width: 100%;

                    & > div > span {
                        margin-right: 30px;
                        cursor: pointer;
                    }

                    .changeBtn {
                        background: #FFFFFF;
                        border: 1px solid #1477C9;
                        font-size: 14px;
                        color: #1477C9;
                    }

                    .active-select {
                        color: #1A77D6;
                    }

                }

                .checkbox-box {
                    display: inline-block;

                    .el-checkbox-group {
                        height: 50px;
                        display: flex;
                        align-items: center;
                    }

                    .checkbox-btn {
                        display: flex;
                        justify-content: center;
                        padding: 20px 0;
                    }
                }
            }
        }
    }
}

.record-list {
    width: 100%;
    box-sizing: border-box;
    .el-col {
        margin-top: 20px;
    }


}
.not-tip{
    margin-top: 20px;
    display: flex;
    width: 100%;
    height: 300px;
    align-items: center;
    justify-content: center;
    background: #fff;
}
</style>